// extracted by mini-css-extract-plugin
export default {"Image":"Image_Image__3UhDR","Image_preview":"Image_Image_preview__27bku"};